// Generated from tools/supplier-catalog/commerce-taxonomy.json. Run sync-commerce-taxonomy.py to update.
export interface CommerceDepartment { handle: string; name: string; description: string; categoryHandles: readonly string[]; }
export const COMMERCE_DEPARTMENTS: readonly CommerceDepartment[] = [
  {
    "handle": "attachments",
    "name": "Attachments",
    "description": "Browse attachments by machine and application.",
    "categoryHandles": [
      "thumbs",
      "hydraulic-thumbs",
      "mechanical-thumbs",
      "pin-on-hydraulic-thumbs",
      "weld-on-hydraulic-thumbs",
      "weld-on-mechanical-thumbs",
      "buckets",
      "digging-buckets",
      "ditching-buckets",
      "augers",
      "grapples",
      "rakes",
      "rippers",
      "asphalt-cutters",
      "quick-couplers",
      "plate-compactors",
      "thumb-replacement-parts",
      "parts-accessories",
      "compactor-replacement-parts",
      "pin-kits",
      "hose-kits",
      "head-plates",
      "replacement-parts",
      "bucket-accessories"
    ]
  },
  {
    "handle": "material-handling",
    "name": "Material Handling",
    "description": "Move and lift materials with pallet jacks, carts, and lifting equipment.",
    "categoryHandles": [
      "pallet-jacks",
      "hand-trucks",
      "platform-trucks",
      "dollies",
      "lift-tables",
      "hoists",
      "cranes",
      "material-lifts"
    ]
  },
  {
    "handle": "loading-dock-equipment",
    "name": "Loading Docks & Ramps",
    "description": "Load equipment and freight with yard ramps and dock equipment.",
    "categoryHandles": [
      "yard-ramps",
      "loading-ramps",
      "truck-ramps",
      "dock-boards",
      "dock-plates",
      "dock-levelers",
      "dock-bumpers",
      "wheel-chocks"
    ]
  },
  {
    "handle": "trailers",
    "name": "Trailers",
    "description": "Find trailers for equipment transport and jobsite hauling.",
    "categoryHandles": [
      "lowboy-trailers",
      "lowboys",
      "equipment-trailers",
      "utility-trailers",
      "dump-trailers",
      "tilt-trailers",
      "gooseneck-trailers"
    ]
  },
  {
    "handle": "workshop-storage",
    "name": "Workshop & Storage",
    "description": "Equip your workspace with tools, workbenches, shelving, and storage.",
    "categoryHandles": [
      "workbenches",
      "work-benches",
      "workbench",
      "shelving",
      "storage-cabinets",
      "tool-cabinets",
      "toolboxes",
      "tool-storage",
      "tools",
      "hand-tools",
      "power-tools",
      "air-compressors",
      "air-compressors-and-tools",
      "portable-air-compressors",
      "portable-electric-air-compressors",
      "stationary-air-compressors",
      "truck-mount-air-compressors",
      "single-stage-air-compressors",
      "air-compressor-accessories",
      "air-compressor-filters-and-regulators",
      "air-compressor-maintenance",
      "air-compressor-tank-drains",
      "air-compressor-motors",
      "air-compressor-pumps",
      "air-compressor-pressure-switches",
      "welders",
      "welding-machines",
      "plasma-cutters",
      "welding-and-metal-fabrication",
      "stick-welding-systems",
      "multi-process-welding-systems",
      "mig-welding-systems",
      "tig-welding-systems",
      "plasma-cutting-systems",
      "welding-tables",
      "fixture-welding-tables",
      "welding-carts-tables-and-clamps",
      "welding-cylinder-torch-carts",
      "welding-cylinder-carts",
      "portable-welding-screen",
      "welding-blankets-curtains",
      "welding-gloves-and-apparel",
      "welding-helmets-and-goggles",
      "welding-kits-and-accessories"
    ]
  },
  {
    "handle": "fuel-tanks",
    "name": "Fuel Tanks & Accessories",
    "description": "Browse transfer tanks, auxiliary tanks, and fuel equipment.",
    "categoryHandles": [
      "transfer-tanks",
      "fuel-transfer-tanks",
      "auxiliary-fuel-tanks",
      "fuel-tanks",
      "fuel-tank-accessories",
      "fuel-pumps"
    ]
  },
  {
    "handle": "waste-recycling",
    "name": "Waste & Recycling",
    "description": "Handle jobsite waste with containers and collection equipment.",
    "categoryHandles": [
      "roll-off-containers",
      "roll-off-dumpsters",
      "dumpsters",
      "self-dumping-hoppers",
      "trash-hoppers",
      "waste-containers"
    ]
  },
  {
    "handle": "site-supplies",
    "name": "Jobsite Supplies",
    "description": "Equip your jobsite with temporary fencing, barricades, and site accessories.",
    "categoryHandles": [
      "temporary-fencing",
      "fence-panels",
      "fence-stands",
      "fence-accessories",
      "crowd-control-barricades"
    ]
  },
  {
    "handle": "wood-chippers",
    "name": "Wood Chippers",
    "description": "Wood chippers here run from 2.5-inch yard models to a 9-inch diesel. Yardbeast covers 2.5 to 7 inches, including two chipper shredders with a leaf hopper. Dosko, Powerhorse, Brave and Bear Cat add 4 to 9 inch machines.",
    "categoryHandles": [
      "residential-wood-chippers",
      "commercial-wood-chippers",
      "chipper-shredders",
      "brush-chippers"
    ]
  },
  {
    "handle": "stump-grinders",
    "name": "Stump Grinders",
    "description": "Stump grinders here are walk-behind Dosko models from 6 to 20 HP, a Brave 14 HP and one self-propelled Dosko.",
    "categoryHandles": [
      "stump-grinders"
    ]
  },
  {
    "handle": "trenchers",
    "name": "Trenchers",
    "description": "Trenchers from MiniTrencher are GeoRipper handheld units. The complete machines have a 74cc, 4.7 HP two-stroke engine and come in 16, 20 and 27 inch depths, each with or without the EZ Kart.",
    "categoryHandles": [
      "handheld-trenchers",
      "trencher-attachments"
    ]
  },
  {
    "handle": "boring-machines",
    "name": "Boring Machines",
    "description": "Boring machines here are the SiBore SB115e and SB215e, battery-powered micro boring machines for sideways holes under walks, drives and landscaping. A Makita 40V MAX XGT battery motor drives them.",
    "categoryHandles": [
      "micro-boring-machines"
    ]
  }
];

export function commerceDepartment(product: { departmentHandle?: string; categoryHandle?: string; machineTypes?: string[]; catalogKind?: string }): CommerceDepartment | undefined {
  return COMMERCE_DEPARTMENTS.find(department => department.handle === product.departmentHandle)
    || COMMERCE_DEPARTMENTS.find(department => department.categoryHandles.includes(product.categoryHandle))
    || (product.machineTypes?.length || product.catalogKind === "Attachment" ? COMMERCE_DEPARTMENTS[0] : undefined);
}
